/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Legal_Entity_HintInputs */

const cs_settings_office_legal_entity_hint = /** @type {(inputs: Settings_Office_Legal_Entity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrovaná firma této franšízy. Pobočky ji převezmou, pokud si nevyberou vlastní.`)
};

const en_settings_office_legal_entity_hint = /** @type {(inputs: Settings_Office_Legal_Entity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registered company for this franchise. Branches inherit it unless they pick their own.`)
};

/**
* | output |
* | --- |
* | "Registered company for this franchise. Branches inherit it unless they pick their own." |
*
* @param {Settings_Office_Legal_Entity_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_legal_entity_hint = /** @type {((inputs?: Settings_Office_Legal_Entity_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Legal_Entity_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_legal_entity_hint(inputs)
	return cs_settings_office_legal_entity_hint(inputs)
});